import { Box } from '@zillow/constellation-10';

import OptimizeForScopeCard from './OptimizeForScopeCard';
import SmartAssignHeader from './SmartAssignHeader';

export function AutoSpotlightPanel({ showSmartAssign = false }: { showSmartAssign?: boolean }) {
  return (
    <Box data-testid="auto-spotlight-panel">{showSmartAssign ? <SmartAssignHeader /> : <OptimizeForScopeCard />}</Box>
  );
}

export default AutoSpotlightPanel;
